import { ChevronLeft, ChevronRight, Database } from 'lucide-react';
import type { ValidationCase } from '../../types/barcodeValidation';

interface Props {
  cases: ValidationCase[];
  currentIndex: number;
  onNavigate: (direction: 'prev' | 'next') => void;
  onLoadSamples: () => void;
}

export function CaseNavigator({ cases, currentIndex, onNavigate, onLoadSamples }: Props) {
  const total = cases.length;
  const currentName = currentIndex >= 0 && currentIndex < total ? cases[currentIndex].name : null;

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2">
        <button
          onClick={onLoadSamples}
          className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-teal-700 bg-teal-50 hover:bg-teal-100 rounded-lg transition-colors font-medium"
        >
          <Database className="w-4 h-4" />
          Amostras
        </button>
      </div>

      {total > 0 && (
        <div className="flex items-center gap-3">
          <button
            onClick={() => onNavigate('prev')}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <ChevronLeft className="w-5 h-5 text-gray-600" />
          </button>

          <div className="text-center min-w-[140px]">
            <p className="text-sm font-bold text-teal-700">
              {currentIndex >= 0 ? currentIndex + 1 : '—'} / {total}
            </p>
            {currentName && (
              <p className="text-xs text-gray-500 truncate max-w-[200px]">{currentName}</p>
            )}
          </div>

          <button
            onClick={() => onNavigate('next')}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <ChevronRight className="w-5 h-5 text-gray-600" />
          </button>
        </div>
      )}
    </div>
  );
}
